import React, { Component } from 'react';
import { Spinner } from "@blueprintjs/core";
import NotesElementContainer from '../../containers/notes/NotesElementContainer';

/**
 * displays NotesElementContainer and allows adding new notes
 * @props {Array} notes
 * @props {bool} isLoading
 * @props {function} addNewNote
 * @returns NotesOverlay
 */
class CurrentNotes extends Component {
	render() {
		return this.currentContent();
	}
	
	currentContent = () => {
		const { isLoading } = this.props;
		if(isLoading) {
			return this.spinner();
		} else {
			return this.noteSection();			
		}
	}
	
	spinner = () => {
		return <div>
			<Spinner />
		</div>; 
	}
	
	noteSection = () => {
		return <div>
			{this.currentNotes()}
			{this.addNoteButton()}
		</div>
	}
	
	currentNotes = () => {
		const { notes, removeNoteStateOnly, saveNote, removeNote } = this.props;
		return notes.map((noteObj, i) => { 
			return <NotesElementContainer
				key = { i }
				noteIndex = { i }
			/>
		});
	}
	
	addNoteButton = () => {
		const { addNewNote } = this.props;
		return <button
			onClick = { addNewNote }
			className = 'pt-button pt-intent-success'
		>
			Add New Note
		</button>
	}
}

export default CurrentNotes;


// WEBPACK FOOTER //
// ./src/components/notes/CurrentNotes.jsx